var versionConfig = {
    v_num: 1.1,//版本号，每次更新代码+1
}

export default versionConfig;